import React, { useEffect, useRef, useState } from 'react';
import { FileText } from 'lucide-react';

interface HTMLPreviewProps {
    htmlContent: string;
    containerWidth?: number;
    containerHeight?: number;
    className?: string;
}

const RichTextPreviewer: React.FC<HTMLPreviewProps> = ({
    htmlContent,
    containerWidth = 1920,
    containerHeight = 1080,
    className = ''
}) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const contentRef = useRef<HTMLDivElement>(null);
    const [scale, setScale] = useState(1);

    // If no content, show placeholder
    if (!htmlContent) {
        return (
            <div className="w-full h-full flex flex-col items-center justify-center gap-1 text-gray-500">
                <FileText className="h-6 w-6" />
                <span className="text-xs">Rich Text Placeholder</span>
            </div>
        );
    }

    useEffect(() => {
        const calculateScale = () => {
            if (containerRef.current && contentRef.current) {
                // Wait for content to render
                setTimeout(() => {
                    if (containerRef.current && contentRef.current) {
                        const containerRect = containerRef.current.getBoundingClientRect();
                        const contentRect = contentRef.current.getBoundingClientRect();

                        const scaleX = containerRect.width / containerWidth;
                        const scaleY = containerRect.height / contentRect.height;
                        
                        // Use the smaller scale to ensure content fits
                        const newScale = Math.min(scaleX, scaleY);
                        setScale(newScale);
                    }
                }, 100);
            }
        };

        calculateScale();
    }, [htmlContent, containerWidth, containerHeight]);

    return (
        <div 
            ref={containerRef}
            // className={`w-full h-full `} 
                // ${className}
            style={{ 
                position: 'relative', 
                overflow: 'hidden',
                width: '100%',
                height: '100%',
            }}
             dangerouslySetInnerHTML={{ __html: htmlContent }}
        >
            {/* <div
                // style={{
                //     position: 'absolute',
                //     top: 0,
                //     left: 0,
                //     transformOrigin: 'top left',
                //     transform: `scale(${scale})`,
                //     width: `${containerWidth}px`,
                // }}
            > */}
                {/* <div
                    ref={contentRef}
                    style={{
                        // width: `${containerWidth}px`,
                        // maxWidth: `${containerWidth}px`,
                        // margin: 0,
                        // padding: 0,
                        // boxSizing: 'border-box',
                    }}
                /> */}
            {/* </div> */}
        </div>
    );
};

export default RichTextPreviewer;